<section class="budget-items-section">
    <div class="budget-items-container">
        <div class="income-column">
            <h1>Income</h1>
            <div class="budget-items">
               <div *ngFor="let item of budgetItems">
                <app-budget-item-card *ngIf="item.amount >=0" [item]='item' (cardClick)="onCardClicked(item)" (xButtonClick)="onDeleteButtonClick(item)" style="display:block;margin-bottom: 20px;"></app-budget-item-card>
               </div> 
       
            </div>
        </div>
        <div class="expenses-column">
            <h1>Expenses</h1>
            <div class="budget-items">
                <div *ngFor="let item of budgetItems">
                 <app-budget-item-card *ngIf="item.amount <0" [item]='item'(cardClick)="onCardClicked(item)" (xButtonClick)="onDeleteButtonClick(item)" style="display:block;margin-bottom: 20px;"></app-budget-item-card>
                </div> 
        
             </div>
        </div>
    </div>
</section>